export const alphabeticalSort = new Intl.Collator('en', { ignorePunctuation: true, numeric: true }).compare
